/**
 * React Query read around `GET /api/personas/:id/recent-conversations` —
 * feeds the composed-prompt inspector's "Rendered for" picker (a short list
 * of this persona's own recent conversations to reconstruct runtime layers
 * against). Mirrors `usePersonaComposedPrompt`'s shape.
 *
 * `staleTime: 60_000` (rather than `Infinity` like the composed-prompt
 * query): unlike the bundle breakdown, this list can change from other
 * activity (a new conversation starting) while the inspector is open, and a
 * fresh list is cheap — no LLM call, just a DB read.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import type { RecentConversation } from '@/types/promptSnapshot'

export function usePersonaRecentConversations(
  personaId: string,
  enabled: boolean,
): UseQueryResult<RecentConversation[], Error> {
  return useQuery<RecentConversation[], Error>({
    queryKey: ['persona-recent-conversations', personaId],
    queryFn: () =>
      apiClient.get<RecentConversation[]>(`/api/personas/${personaId}/recent-conversations`),
    enabled,
    staleTime: 60_000,
    retry: false,
  })
}
